import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import ProblemSection from './components/ProblemSection';
import WhyUsSection from './components/WhyUsSection';
import InteractiveCheckSection from './components/InteractiveCheckSection';
import SecondaryCTA from './components/SecondaryCTA';
import Footer from './components/Footer';
import { Questionnaire } from './components/Questionnaire';

const App: React.FC = () => {
  const [isQuestionnaireOpen, setIsQuestionnaireOpen] = useState(false);
  const [isLeadSuccess, setIsLeadSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  const handleStartCheck = (email: string = '') => {
    setUserEmail(email);
    setIsQuestionnaireOpen(true);
    // Smooth scroll to top when opening questionnaire
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLeadSubmit = (email: string) => {
    setUserEmail(email);
    setIsLeadSuccess(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCloseQuestionnaire = () => {
    setIsQuestionnaireOpen(false);
    setIsLeadSuccess(false);
    setUserEmail('');
  };

  return (
    <div className="min-h-screen bg-white selection:bg-accent selection:text-white flex flex-col">
      {isQuestionnaireOpen || isLeadSuccess ? (
        <Questionnaire 
          initialEmail={userEmail} 
          onClose={handleCloseQuestionnaire} 
          forceSuccess={isLeadSuccess}
        />
      ) : (
        <>
          <Header />
          <Hero onLeadSubmit={handleLeadSubmit} onStartCheck={() => handleStartCheck()} />
          <TrustBar />
          <ProblemSection />
          <WhyUsSection />
          <InteractiveCheckSection onStart={() => handleStartCheck()} />
          <SecondaryCTA />
          <Footer />
        </>
      )}
    </div>
  );
};

export default App;